import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AppContext } from "../../../context/AppContext";
import PageFooter from "../Footer/PageFooter";
import MobileNavBar from "../header/MobileNavBar/MobileNavBar";
import { StyledPageLayout } from "./styles";

const PageLayout = ({ children }) => {
  const {
    isSidebarOpen,
    prevSidebarOpen,
    isTabletScreen,
    updateMobileScreen,
    updateTabletScreen,
    updateSidebar,
    updatePrevSidebar,
    updateSelectedOption,
  } = useContext(AppContext);
  const location = useLocation();

  const isGamePlayerPage = location.pathname === "/play";
  const isSportsbookPage =
    location.pathname === "/sports" || location.pathname.startsWith("/sports/match/");

  const handleWindowResize = () => {
    if (window.innerWidth < 576) {
      updateMobileScreen(true);
    } else {
      updateMobileScreen(false);
    }

    if (window.innerWidth < 1024) {
      updateTabletScreen(true);
    } else {
      updateTabletScreen(false);
    }
  };

  useEffect(() => {
    // Call handleWindowResize when the component mounts to set isTabletScreen initially
    handleWindowResize();

    updateSelectedOption(location.pathname);

    // Attach the event listener when the component mounts
    window.addEventListener("resize", handleWindowResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  // Keep the sidebar state coherent when switching between desktop and mobile layouts.
  useEffect(() => {
    if (isTabletScreen) {
      if (isSidebarOpen) updatePrevSidebar(true);
      updateSidebar(false);
    } else {
      if (prevSidebarOpen) {
        updateSidebar(true);
        updatePrevSidebar(false);
      }
    }
  }, [isTabletScreen]);

  // Sportsbook owns three dense desktop columns, so start its outer app rail
  // collapsed. The sidebar state itself is intentionally not a dependency:
  // once a user reopens the rail, query tabs and match-detail navigation keep
  // that explicit choice until the route family changes.
  useEffect(() => {
    if (isTabletScreen) return;

    updatePrevSidebar(false);
    updateSidebar(!isSportsbookPage);
    // Context actions are intentionally excluded: their identities change
    // with provider renders and would re-close a sidebar the user reopened.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSportsbookPage, isTabletScreen]);

  return (
    <StyledPageLayout $isSidebarOpen={isSidebarOpen} $isGamePlayerPage={isGamePlayerPage}>
      <>{children}</>

      {!isGamePlayerPage && !isSportsbookPage && <PageFooter />}
      {isTabletScreen && !isGamePlayerPage && <MobileNavBar />}
    </StyledPageLayout>
  );
};

export default PageLayout;
